import * as Yup from 'yup';
import { FieldType } from '@typedefs/modulesInterfaces';
import type { ClassicInputGroup, CalendarYearSelectGroup } from '@typedefs/modulesInterfaces';
import { validatePositiveNumber } from '@pages/activityBuilder/modules/moduleUtils';

export interface BiodiversityActivityFormValues {
	activityTitle: string;
	startYear: number;
	endYear: number;
}

export const activityTitleField: ClassicInputGroup = {
	type: FieldType.CLASSIC,
	inputName: 'activityTitle',
	inputType: 'text',
	label: 'activity.activity_title',
};

export const startYearField: CalendarYearSelectGroup = {
	type: FieldType.CALENDAR_YEAR_SELECT,
	inputName: 'startYear',
	label: 'activity.start_year',
	unit: '[years]',
	startYear: 1900,
	endYear: 2100,
};

export const endYearField: CalendarYearSelectGroup = {
	type: FieldType.CALENDAR_YEAR_SELECT,
	inputName: 'endYear',
	label: 'activity.last_year_of_accounting_t2',
	unit: '[years]',
	startYear: 1900,
	endYear: 2100,
};

export const biodiversityActivityValidationSchema = Yup.object({
	activityTitle: Yup.string()
		.required('validations.activity_name_required')
		.min(3, 'validations.activity_name_min')
		.max(100, 'validations.activity_name_max'),
	startYear: validatePositiveNumber
		.required()
		.min(1900)
		.test('start-year-end-year-check', 'validations.activity_start_year_end_year_check', function (value) {
			const { endYear } = this.parent;
			return Boolean(value && value < endYear);
		}),
	endYear: validatePositiveNumber.required().min(1900),
});
